// State atoms exclusive for new Price Calculator. Reusable atoms are located in priceIntentAtoms

import { atom, useAtom, useAtomValue } from 'jotai'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { type SbBlokData } from '@storyblok/react'

export const priceCalculatorDeductibleInfoAtom = atom<Array<SbBlokData> | null>(null)

export const usePriceCalculatorDeductibleInfo = () => {
  const value = useAtomValue(priceCalculatorDeductibleInfoAtom)
  if (value == null) {
    throw new Error('Expected to have price calculator deductible info')
  }
  return value
}

export const priceCalculatorInsuranceAmountInfoAtom = atom<Array<SbBlokData> | null>(null)

export const usePriceCalculatorInsuranceAmountInfo = () => {
  return useAtomValue(priceCalculatorInsuranceAmountInfoAtom)
}

export const priceCalculatorNonTierCoverageInfoAtom = atom<Array<SbBlokData> | null>(null)

export const usePriceCalculatorNonTierCoverageInfo = () => {
  const value = useAtomValue(priceCalculatorNonTierCoverageInfoAtom)
  if (value == null) {
    throw new Error('Expected to have price calculator non-tier coverage info')
  }
  return value
}

export const tiersSectionAtom = atom<Array<SbBlokData>>([])

export function useTiersSectionAtom() {
  const value = useAtomValue(tiersSectionAtom)
  return value
}

export const purchaseSummaryAtom = atom<Array<SbBlokData> | null>(null)

export const usePurchaseSummaryAtom = () => {
  const value = useAtomValue(purchaseSummaryAtom)
  return value
}

export const priceCalculatorShowEditSsnWarningAtom = atom(false)

export const priceCalculatorAddedOffer = atom<ProductOfferFragment | null>(null)

export const priceCalculatorLoadingAtom = atom(false)

export const usePriceCalculatorLoadingState = () => useAtom(priceCalculatorLoadingAtom)

export const priceCalculatorPromoteInboundSalesAtom = atom<boolean>(false)

export function usePromoteInboundSales() {
  return useAtomValue(priceCalculatorPromoteInboundSalesAtom)
}
